import { useEnableUnifiedMenu } from 'hooks/use-enable-unified-menu';
import { useMainMenuContext } from 'state/menu/main-menu';

export const useIsLegacyCartReady = () => {
  const isUnifiedMenuEnabled = useEnableUnifiedMenu();
  const { storeMenuLoading, storeMenuCalled } = useMainMenuContext();

  const loadingLegacyMenu = !isUnifiedMenuEnabled && (!storeMenuCalled || storeMenuLoading);
  if (loadingLegacyMenu) {
    return false;
  }

  return true;
};
